import React, { useState, useEffect } from "react";
import { Layout, Menu, Card } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import pose1 from "../../Assets/Tool/pose.jpg";
import { API_BASE_URL } from "../../Config";
import axios from "axios";
import dummyImg from "../../Assets/dummyImg.jpg";
import Pose1 from "../../Assets/Tool/yoga1.jpg";
import Pose2 from "../../Assets/Tool/yoga2.jpg";
import Pose3 from "../../Assets/Tool/yoga3.jpg";
import Pose4 from "../../Assets/Tool/yoga4.jpg";
import Pose5 from "../../Assets/Tool/yoga5.jpg";
import AdvertisementCard from "../AdvertisementCard";

const { Sider, Content } = Layout;

const Tool = () => {
  const [selectedKey, setSelectedKey] = useState("home");
  const [allYogaPages, setAllYogaPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllYoga = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/allpages?page=tool`);
        const json = await res.data;
        setAllYogaPages(json?.data || []);
      } catch (error) {
        console.error("API Fetch Error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllYoga();
  }, []);

  const getDynamicPageContent = (key) => {
    if (key === "home") {
      const home = allYogaPages.find((p) => p.yogaType === "Yoga Main Page");

      if (home) return home.content;

      return `
      <p style="font-size:16px; max-width:700px; margin:0 auto 30px; text-align:center;">
  These pieces of equipment greatly enhance yoga practice in many ways. Let's take a closer look at how each one helps.
</p>

<div>
  <h2 style="margin-bottom:10px; font-size:28px;">1. Yoga Instructor</h2>

  <p style="font-size:16px; max-width:700px; margin:0 auto 30px;">
    Yoga without a trainer is like a journey without a guide.
  </p>

  

  <h3 style="margin-top:25px;">Why a Yoga Instructor is Important</h3>

  <ul style="line-height:1.8; font-size:16px;">
    <li><b>Correct posture and alignment:</b> They correct your body's alignment and prevent injuries.</li>
    <li><b>Personalized information:</b> They adapt the exercises to each person's unique needs (injuries, stiffness).</li>
    <li><b>Motivation and encouragement:</b> They encourage you at the right time and help you try challenging poses.</li>
    <li><b>Safety:</b> They protect you from dangerous poses and guide you to progress gradually.</li>
  </ul>

  <h3 style="margin-top:20px;">Note:</h3>

  <ol style="line-height:1.8; font-size:16px;">
    <li>Doing yoga with the help of a yoga expert or yoga trainer near you will help you avoid injuries, pain, and muscle cramps.</li>
    <li>Also, their help will help you improve your practice and learn yoga asanas quickly.</li>
    <li>They will take you under control, guide you well, and gradually progress you from beginner to intermediate and advanced yoga levels.</li>
    <li>It is your duty to choose a good and qualified yoga expert.</li>
    <li>Even if you get a good yoga expert, it is your duty to be a good student. Daily practice, even if obstacles come, it is necessary to try again.</li>
    <li>Please inform your yoga practitioner of any medical conditions you may have <b>(diabetes, respiratory problems, high blood pressure, heart disease, or other conditions),</b> especially for women <b>(menstruation or pregnancy)</b>, so that they can help you practice the asana that is right for your physical condition.</li>
  </ol>

  <hr style="margin-top:40px; color:#dddddd;" />
</div>

<div>
  <h2 style="margin-bottom:10px; font-size:28px;">2. Yoga Block / Brick</h2>

  <p style="font-size:16px; max-width:700px; margin:0 auto 30px;">
    This is like a "stretcher" that extends the floor when your hands don't reach the floor.
  </p>

  <img src="${Pose1}" alt="Yoga Block / Brick" />

  <p style="font-size:16px; margin-top:15px;"><b>Example:</b> Gorakshasana</p>

  <h3 style="margin-top:25px;">Benefits of Yoga Block / Brick</h3>

  <ul style="line-height:1.8; font-size:16px;">
    <li><b>Access:</b> Makes difficult poses like Sirasasana (Headstand) easier.</li>
    <li><b>Depth:</b> Allows for deep muscle stretching in poses like Forward Fold.</li>
    <li><b>Balance:</b> Helps maintain balance in standing poses.</li>
    <li><b>Strengthening:</b> Strengthens muscles by using them as resistance in some exercises.</li>
  </ul>

  <hr style="margin-top:40px; color:#dddddd;" />
</div>

<div>
  <h2 style="margin-bottom:10px; font-size:28px;">3. Wall</h2>

  <p style="font-size:16px; max-width:700px; margin:0 auto 30px;">
    A wall is a stable and reliable yoga partner.
  </p>

  <img src="${Pose2}" alt="Wall Yoga" />

  <p style="font-size:16px; margin-top:15px;"><b>Example:</b> Shirshasana or Headstand pose</p>

  <h3 style="margin-top:25px;">Benefits of Wall</h3>

  <ul style="line-height:1.8; font-size:16px;">
    <li><b>Balance and Support:</b> Helps you relax completely in poses like Legs-Up-the-Wall Pose.</li>
    <li><b>Alignment:</b> Helps you learn proper alignment of your knees, hips, and shoulders by placing your heels on the wall in standing poses.</li>
    <li><b>Deep Stretching:</b> Use a wall to provide deep stretches for the chest, shoulders, and spine.</li>
  </ul>

  <hr style="margin-top:40px; color:#dddddd;" />
</div>

<div>
  <h2 style="margin-bottom:10px; font-size:28px;">4. Yoga Stretch Belt</h2>

  <p style="font-size:16px; max-width:700px; margin:0 auto 30px;">
    This belt is an excellent tool for properly stretching stretched muscles and deepening asanas.
  </p>

  <p style="font-size:16px; max-width:700px; margin:0 auto 15px;">
    This is a tool that increases the rapid extension of your arms.
  </p>

  <img src="${Pose3}" alt="Yoga Stretch Belt" />

  <p style="font-size:16px; margin-top:15px;"><b>Example:</b> Eka Pada Raja Kapotasana</p>

  <h3 style="margin-top:25px;">Benefits of Yoga Stretch Belt</h3>

  <ul style="line-height:1.8; font-size:16px;">
    <li><b>Access:</b> Helps you easily access your legs in poses that are difficult to hold (e.g., Hero Pose).</li>
    <li><b>Maintaining Stretch:</b> Helps you maintain a stretch for a longer period of time without holding your muscles rigid while stretching.</li>
    <li><b>Injury Management:</b> Allows for safe practice for those with shoulder or hamstring injuries.</li>
  </ul>

  <hr style="margin-top:40px; color:#dddddd;" />
</div>

<div>
  <h2 style="margin-bottom:10px; font-size:28px;">5. Yoga Wheel</h2>

  <p style="font-size:16px; max-width:700px; margin:0 auto 30px;">
    This is a powerful massage tool for the spine and chest area.
  </p>

  <img src="${Pose4}" alt="Yoga Wheel" />

  <p style="font-size:16px; margin-top:15px;"><b>Example:</b> Matsyasana</p>

  <h3 style="margin-top:25px;">Benefits of Yoga Wheel</h3>

  <ul style="line-height:1.8; font-size:16px;">
    <li><b>Spinal Flexibility:</b> Helps to flex the spine and regain its flexibility.</li>
    <li><b>Chest Opening:</b> Helps to open the chest and shoulder areas, especially for those who sit for long hours.</li>
    <li><b>Massage:</b> Provides a deep massage to tight muscles in areas such as the back, shoulders, and buttocks.</li>
  </ul>

  <hr style="margin-top:40px; color:#dddddd;" />
</div>

<div>
  <h2 style="margin-bottom:10px; font-size:28px;">6. Chair</h2>

  <p style="font-size:16px; max-width:700px; margin:0 auto 30px;">
    Chair yoga is a unique practice method that makes yoga accessible to everyone.
  </p>

  <img src="${Pose5}" alt="Chair Yoga" />

  <p style="font-size:16px; margin-top:15px;"><b>Example:</b> Eka Pada Raja Kapotasana</p>

  <h3 style="margin-top:25px;">Benefits of Chair</h3>

  <ul style="line-height:1.8; font-size:16px;">
    <li><b>Suitable for everyone:</b> It is very safe for the elderly, those with injuries, or those with balance problems.</li>
    <li><b>Support:</b> The chair provides support, allowing you to do poses with added stability.</li>
    <li><b>Strength and Flexibility:</b> Using a chair, you can strengthen and stretch many areas such as the arms, legs, and spine.</li>
  </ul>

  <hr style="margin-top:40px; color:#dddddd;" />
</div>

<div>
  <h3 style="margin-top:20px;">In Conclusion:</h3>

  <p style="font-size:16px; max-width:700px; margin:0 auto 30px; line-height:1.8;">
    These tools will not only enhance your training, but also make it safer, more efficient, and more enjoyable. They do not replace the role of the trainer, but are great tools to help you follow his or her instructions.
  </p>
</div>

`;
    }

    const page = allYogaPages.find((p) => p._id === key);
    return page?.content || "<p>No content found.</p>";
  };

  const menuItems = [
    ...allYogaPages.map((p) => ({
      key: p._id,
      label: p.yogaType,
    })),
    { key: "home", label: "Back to Main Page" },
  ];

  const selectedContent = (
    <div
      className="page-content"
      dangerouslySetInnerHTML={{ __html: getDynamicPageContent(selectedKey) }}
    />
  );

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "30px 10px",
        minHeight: "100vh",
        background: "#f0f2f5",
      }}
    >
      <Layout
        className="responsive"
        style={{
          width: "90%",
          maxWidth: "1200px",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Sider
          className="sub_slider"
          width={250}
          style={{
            height: "900px", // 👈 decrease height here
            backgroundImage: `url(${pose1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0,0,0,0.6)",
            }}
          />

          <div
            style={{
              position: "relative",
              zIndex: 2,
              padding: "16px",
              fontWeight: "bold",
              textAlign: "center",
              color: "#fff",
            }}
          >
            Explore Yoga Types
          </div>

          <Menu
            theme="white"
            mode="inline"
            style={{
              background: "transparent",
              color: "#ffffffA2",
              fontSize: "1.1rem",
              position: "relative",
              zIndex: 2,
              fontWeight: 500,
              textAlign: "center",
            }}
            itemStyle={{ color: "#fff" }}
            onClick={(e) => setSelectedKey(e.key)}
            selectedKeys={[selectedKey]}
            items={menuItems}
          />
        </Sider>

        <Content className="content_responsive" style={{ padding: "30px" }}>
          {loading ? (
            <h2>Loading...</h2>
          ) : (
            <AnimatePresence mode="wait">
              <motion.div
                key={selectedKey}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
              >
                <Card style={{ borderRadius: "12px", padding: "24px" }}>
                  {selectedContent}
                </Card>
              </motion.div>
            </AnimatePresence>
          )}
        </Content>
      </Layout>
      <AdvertisementCard />
    </motion.div>
  );
};

export default Tool;
